import {
  UPLOADED_ITEM_PROMOTIONS,
  PromotionStorageKeys,
} from '@marketplace-web/item-upload/item-upload-data'
import {
  getLocalStorageItem,
  removeLocalStorageItem,
} from '@marketplace-web/browser/browser-storage-util'

export const getPromotionsFromLocalStorage = () => {
  const uploadedItemPromotionsFromStorage = getLocalStorageItem(UPLOADED_ITEM_PROMOTIONS)
  const parsedItemPromotions: Array<PromotionStorageKeys> = JSON.parse(
    uploadedItemPromotionsFromStorage || '[]',
  )

  removeLocalStorageItem(UPLOADED_ITEM_PROMOTIONS)

  return {
    bumped: parsedItemPromotions.includes(PromotionStorageKeys.ShowBumped),
    feedback: parsedItemPromotions.includes(PromotionStorageKeys.ShowFeedback),
    uploadAnotherItemTip: parsedItemPromotions.includes(
      PromotionStorageKeys.ShowUploadAnotherItemTip,
    ),
  }
}
